module.exports = __webpack_public_path__ + "static/img/channel-3-2.2cac37a7.png";